







import * as echarts from "echarts";
import { getTimeStr } from '@/common/time';
import { defineComponent, onMounted, ref, watch, onBeforeUnmount, shallowRef } from "@vue/composition-api";
import { TitlesType, ChartType } from "../types";
import { debounce, toThousands } from "@/common/util";
import { showUnitYaxis } from '../filter';
type legendData = {
    name: String,
    itemStyle: {
        color: string
    },
}
export default defineComponent({
    components: {},
    props: {
        showLegend: {
            type: Boolean,
            default: true
        },
        isLong: {
            type: Boolean,
            default: false
        },
        isShowYName: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        selected: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showInteger: { // Y轴是否展示小数
            type: Boolean,
            default: false
        },
        chartSetting: {
            type: Object,
            default: () => {}
        }
    },
    setup(props, context) {
        const myChart = shallowRef();
        const showNoData = ref(false);

        function domReturn(params: { color: string; value: string; seriesName: string; axisValue: string}[]) {
            let dom = ""
            params.map((m: { color: string; value: string; seriesName: string;axisValue: string}, ) => {
                const val = props.data.titles.find((item:TitlesType) => item.fieldName === m.seriesName);
                dom += `
                    <div style="display:flex;justify-content:space-between;color:#333840; margin-top: 10px; line-height:20px">
                        <div style="display:flex;justify-content:start; align-items: center;line-height:20px">
                            <span style="display:inline-block;width:10px;height: 3px;background: ${m.color};margin-right: 5px;margin-top: 3px"></span>
                            <span>${val.displayName || '暂无名称'}</span>
                        </div>
                        <div style="margin-left:50px">
                            ${toThousands(m.value, !Number.isInteger(m.value)) + (val && val.displaySetting && JSON.parse(val.displaySetting).extraUnit || '')}
                        </div>
                    </div>
                `
            })
            return dom;
        }

        const optionData = ref<any>({
            legend: {
                data: [] as legendData[],
                z: 4,
                selectedMode: true,
                show: props.showLegend,
                bottom: 0,
                itemWidth: 10,
                itemHeight: 3,
                icon: 'rect',
                selected: {},
                formatter: function (val: string) {
                    return props.data.titles.find((item:TitlesType) => item.fieldName === val).displayName || '暂无名称'
                }
            },
            grid: {
                left: 15,
                right: 15,
                top: props.isShowYName ? 60 : 30,
                containLabel: true,
                bottom: 40
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: '#FFFFFF',
                textStyle: {
                    align: 'left'
                },
                formatter: (params: { color: string; value: string; seriesName: string; axisValue: string}[]) => {
                    const dom = `
                        <div style="padding: 8px 10px 10px 10px;fontSize:12px;background:'#ffffff'">
                            <div style="color:#8A9199;lineHeight:20px">
                                ${params[0].axisValue}
                            </div>
                            <div>
                                ${domReturn(params)}
                            </div>

                        </div>
                    `
                    return dom;
                }
            },
            xAxis: {},
            yAxis: [] as any,
            series: [] as any,
            // toolbox: {
            //     right: 50,
            //     feature: {
            //         myTool1: {
            //             show: true,
            //             title: '自定义扩展方法1',
            //             icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
            //             onclick: function (){
            //                 alwaysShowContentStatus.value = !alwaysShowContentStatus.value;
            //             }
            //         },
            //     }
            // },
        });
        const chartEl = ref(null);
        function initChart() {
            myChart.value = echarts.init(chartEl.value);
            optionData.value && myChart.value.setOption(optionData.value);
            // 监听图例点击至少保留一个
            // myChart.value.on('legendselectchanged', function (params: any) {
            //     const selected = myChart.value.getOption().legend.selected;
            //     const hasSelected = Object.values(params.selected).some(Boolean);
            //     if(!hasSelected) {
            //         const firstSeriesName = myChart.value.getOption().series[0].name;
            //         myChart.value.dispatchAction({
            //             type: 'legendSelect',
            //             name: firstSeriesName
            //         });
            //         context.root.$message.warning(
            //             '图例至少存在一个',
            //         );
            //     }
            // })
        }
        function resizeHandler() {
            myChart.value && myChart.value.resize();
        }
        const cancalDebounce = debounce(resizeHandler, 50);

        // 处理legendData
        function legendDataFunc(val: ChartType) {
            const data = val.titles.filter((m: TitlesType) => m.fieldName !== 'p_date');
            const legend: { name: string; itemStyle: { color: string; }; }[] = [];
            data.map((m: TitlesType) => {
                const item = {
                    name: m.fieldName,
                    itemStyle: {
                        color: (m.displaySetting && JSON.parse(m.displaySetting).color) || ''
                    },
                }
                legend.push(item)
            });
            optionData.value.legend.data = legend;
        }
        // 处理selected
        function selectedFunc(val: ChartType) {
            if(Object.keys(props.selected).length) {
                optionData.value.legend.selected = props.selected;
            } else {
                const data = val.titles.filter((m: TitlesType) => m.fieldName !== 'p_date');
                const selected: {[key: string]: boolean} = {};
                data.map((m: TitlesType) => {
                    selected[m.fieldName] = true;
                });
                if(data.length === 1) {
                    optionData.value.legend.show = false;
                }
                optionData.value.legend.selected = selected;
            }
        }
        // 处理xAxis
        function xAxisFunc(val: ChartType) {
            const xAxis = {
                type: 'category',
                data: [] as string[],
                axisLabel: {
                    interval: 0,
                    rotate: 0,
                    alignMinLabel: 'left',
                    alignMaxLabel: 'right',
                    textStyle: {
                        color: "#8A9199",
                        fontSize: "12px"
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: '#EDEFF2'
                    }
                },
                axisTick: {
                    alignWithLabel: true
                }
            };
            let timeData: string[] = [];
            val.records.map((m: {[key: string]: string}) => {
                timeData.push(m.p_date)
            });
            timeData = timeData.sort((a, b) => Number(a) - Number(b));
            timeData.map(m => {
                // xAxis.data.push(getTimeStr(m));
                xAxis.data.push(getTimeStr(m));
            });
            if(props.isLong) {
                xAxis.axisLabel.interval = xAxis.data.length > 8 ? Math.ceil(xAxis.data.length / 8) : 0
            } else {
                xAxis.axisLabel.interval = xAxis.data.length > 4 ? Math.ceil(xAxis.data.length / 4) : 0
            }

            optionData.value.xAxis = xAxis;
        }
        // 处理yAxis
        function yAxisFunc(val: ChartType) {
            const data = val.titles.filter((m: TitlesType) => m.fieldName !== 'p_date');
            const yAxis = [] as any;
            let titlesDisplaySetting: string[] = [];
            data.map((m: TitlesType) => {
                titlesDisplaySetting.push(m.displaySetting && JSON.parse(m.displaySetting).unit || '')
            })
            // 去重
            titlesDisplaySetting = [...new Set(titlesDisplaySetting)];
            titlesDisplaySetting.map((m: string, i: number) => {
                yAxis.push({
                    type: 'value',
                    name: titlesDisplaySetting.length > 1 ? m : '',
                    splitNumber: 4,
                    alignTicks: true,
                    // minWidth: 50,
                    scale: true,
                    min: 0,
                    interval: null,
                    nameTextStyle: {
                        // align: i > 0 ? 'left' : 'right',
                        // align: 'center',
                        lineHeight: 30,
                        padding:  i > 0 ? [0, 0, 0, 22] : [0, 36, 0, 0] ,
                    },
                    axisLabel: {
                        formatter: function(value: number) {
                            // const val = props.data.titles.find((item:TitlesType) => item.fieldName === m.seriesName);
                            if(props.chartSetting && props.chartSetting.yExtraUnit) {
                                return `${value}${props.chartSetting.yExtraUnit}`
                            }
                            return value;
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#EDEFF2"
                        }
                    }
                })
            })
            optionData.value.yAxis = yAxis;
        }
        // 处理series
        function seriesFunc(val: ChartType | any) {
            const data = val.titles.filter((m: TitlesType) => m.fieldName !== 'p_date');
            const series: any = [];
            const keyData: {code: string, name: string}[] = [];
            // 循环titles拿到单条指标对应的Y轴
            const titlesDisplaySetting: string[] = [];
            data.map((m: any) => {
                keyData.push({
                    code: m.fieldName,
                    name: m.displayName
                })
                if(m.displaySetting && JSON.parse(m.displaySetting).unit && !titlesDisplaySetting.includes(m.displaySetting && JSON.parse(m.displaySetting).unit)) {
                    titlesDisplaySetting.push(JSON.parse(m.displaySetting).unit)
                }
            })
            // 循环取出对应name
            const yAxisIndexObj = [] as {name: string, index: number, unit: string}[];
            data.map((m: TitlesType) => {
                if(titlesDisplaySetting.length) {
                    titlesDisplaySetting.map((item: string, index: number) => {
                        if(m.displaySetting && JSON.parse(m.displaySetting).unit && JSON.parse(m.displaySetting).unit === item) {
                            yAxisIndexObj.push({
                                name: m.fieldName,
                                index,
                                unit: item
                            })
                        }
                    })
                }
            })
            // 循环所有key为series取data数据
            if(keyData.length) {
                keyData.map((m: {code: string, name: string}) => {
                    const data = {
                        data: [] as any,
                        type: 'line',
                        name: m.code,
                        colorBy: 'data',
                        symbol: val.records.length > 1 ? 'none' : '',
                        yAxisIndex: yAxisIndexObj.length ? yAxisIndexObj.find((item: {name: string,index: number,unit: string}) => m.code === item.name)!.index : 0,
                        itemStyle: {
                            color: val.titles.find((item: any) => item.fieldName === m.code).displaySetting && JSON.parse(val.titles.find((item: any) => item.fieldName === m.code).displaySetting).color || ""
                        }
                    }
                    val.records.map((item: {[key: string]: string}) => {
                        data.data.push(item[m.code].includes('%') ? item[m.code].replace(/%/g,"") : (item[m.code] || '0'))
                    });
                    series.push(data);
                })
            }
            optionData.value.series = series;
        }

        // 双Y轴刻度统一
        function yAxisSplitNumber() {
            const isDoubleY = optionData.value.yAxis.length > 1;
            const arr1: number[] = [];
            const arr2: number[] = [];
            optionData.value.series.map((m: any) => {
                if(m.yAxisIndex === 0) {
                    arr1.push(...m.data)
                } else if(m.yAxisIndex === 1 && isDoubleY) {
                    arr2.push(...m.data)
                }
            })
            if(isDoubleY) {
                const arr2InterMax = Math.ceil(Math.max(...arr2));
                const arr2InterMin = Math.floor(Math.min(...arr2));
                // optionData.value.yAxis[1].interval = (arr2InterMax - arr2InterMin) / 4 < 1 ? arr2InterMax / 4 : (arr2InterMax - arr2InterMin) / 4
                // optionData.value.yAxis[1].min = (arr2.length > 1 && (arr2InterMax - arr2InterMin > 0)) ? arr2InterMin : 0;
                // optionData.value.yAxis[1].max = arr2InterMax === 0 ? 4 : arr2InterMax;
                if(arr2InterMax === 0) optionData.value.yAxis[1].max = 4;
                // if(arr2InterMax === 0) optionData.value.yAxis[1].min = 0;
                // if(optionData.value.yAxis[1].interval === 0) {
                //     optionData.value.yAxis[1].interval = 1
                // }
            }
            const arr1InterMax = Math.ceil(Math.max(...arr1));
            const arr1InterMin = Math.floor(Math.min(...arr1));
            // optionData.value.yAxis[0].max = arr1InterMax === 0 ? 4 : arr1InterMax;
            // optionData.value.yAxis[0].max = arr1InterMax === 0 ? 4 : arr1InterMax;
            // optionData.value.yAxis[0].interval = (arr1InterMax - arr1InterMin) / 4 < 1 ? arr1InterMax / 4 : (arr1InterMax - arr1InterMin) / 4;
            // optionData.value.yAxis[0].min = (arr1.length > 1 && (arr1InterMax - arr1InterMin > 0)) ? arr1InterMin : 0;
            if(arr1InterMax === 0) optionData.value.yAxis[0].max = 4;
            // if(optionData.value.yAxis[0].interval === 0) {
            //     optionData.value.yAxis[0].interval = 1
            // }
        }


        onBeforeUnmount(() => {
            window.removeEventListener('resize', cancalDebounce)
            myChart.value && myChart.value.dispose()
        });

        function init() {
            legendDataFunc(props.data as ChartType);
            selectedFunc(props.data as ChartType);
            xAxisFunc(props.data as ChartType);
            yAxisFunc(props.data as ChartType);
            seriesFunc(props.data as ChartType);
            // if(optionData.value.yAxis.length > 1) {
            //     yAxisSplitNumber();
            // }
            yAxisSplitNumber();
        }

        onMounted(async () => {
            if(!props.data.records.length) {
                showNoData.value = true;
                return
            }
            if(props.data.titles.length === 1 && props.data.titles[0].fieldName === 'p_date') {
                showNoData.value = true;
                return
            }
            init();
            initChart();
            myChart.value.setOption(optionData.value);
            window.addEventListener('resize', cancalDebounce);
        });

        function changeLegend(val: string) {
            if(!props.showLegend) {
                optionData.value.legend.selected[val] = !optionData.value.legend.selected[val];
                // 获取当前有几个单位，如果只剩一个，则隐藏另外一个，并且alignTicks设置为false，为true的话，计算可能有问题
                // 获取当前为true的select，然后再拿到对应的单位[{'val': '次'}],最终重组合成=>['次', '收入']；
                const units = showUnitYaxis(optionData.value.legend, props.data as ChartType);
                // const  optionData.value.yAxis[0] = optionData.value.yAxis[0];
                const yAxisNameLeft = optionData.value.yAxis[0];
                const yAxisNameRight = optionData.value.yAxis[1];
                if(units.length === 0) return;
                if(units.includes( yAxisNameLeft.name) && units.includes(yAxisNameRight.name)) {
                    optionData.value.yAxis[0].show = true;
                    optionData.value.yAxis[1].show = true;
                    optionData.value.yAxis[0].alignTicks = true;
                    optionData.value.yAxis[1].alignTicks = true;
                    // 更新数据
                    myChart.value.setOption(optionData.value);
                    return;
                }
                // 如果没有左侧Y轴的单位
                if(!units.includes(yAxisNameLeft.name)) {
                    // 左侧隐藏
                    optionData.value.yAxis[0].show = false;
                    // 右侧展示
                    optionData.value.yAxis[1].show = true;
                    // 自动对齐关闭
                    optionData.value.yAxis[1].alignTicks = false;
                    optionData.value.yAxis[0].alignTicks = false;
                    // 更新数据
                    myChart.value.setOption(optionData.value);
                    return;
                }
                // 如果没有右侧侧Y轴的单位
                if(!units.includes(yAxisNameRight.name)) {
                    // 左侧展示
                    optionData.value.yAxis[0].show = true;
                    // 右侧隐藏
                    optionData.value.yAxis[1].show = false;
                    // 自动对齐关闭
                    optionData.value.yAxis[0].alignTicks = false;
                    optionData.value.yAxis[1].alignTicks = false;
                    // 更新数据
                    myChart.value.setOption(optionData.value);
                    return;
                }
            }
        }
        watch(
            () => props.data,
            () => {
                if(!props.data.records.length) {
                    showNoData.value = true;
                    return
                }
                if(props.data.titles.length === 1 && props.data.titles[0].fieldName === 'p_date') {
                    showNoData.value = true;
                    return
                }
                init();
                myChart.value.setOption(optionData.value);
            },
            {deep: true}
        )
        watch(
            () => optionData.value.legend,
            (val, newVal) => {
                const arr:boolean[] = [];
                (Object.keys(optionData.value.legend.selected)).forEach(m => {
                    arr.push(optionData.value.legend.selected[m]);
                });
                if(arr.every(m => m === false)) {
                    showNoData.value = true;
                    // context.root.$message.warning(
                    //     '图例至少存在一个',
                    // );
                    // optionData.value.legend.selected = val;
                } else {
                    showNoData.value = false;
                }
            },
            {
                deep: true
            }
        )
        return {
            chartEl,
            changeLegend,
            showNoData,
            domReturn
        };
    },
});
